
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 22a9.733 9.733 0 01-3.9-.788 10.092 10.092 0 01-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.733 9.733 0 012 12c0-1.383.263-2.683.788-3.9a10.092 10.092 0 012.137-3.175c.9-.9 1.958-1.613 3.175-2.138A9.743 9.743 0 0112 2c1.383 0 2.683.262 3.9.787a10.105 10.105 0 013.175 2.138c.9.9 1.612 1.958 2.137 3.175A9.733 9.733 0 0122 12a9.733 9.733 0 01-.788 3.9 10.092 10.092 0 01-2.137 3.175c-.9.9-1.958 1.612-3.175 2.137A9.733 9.733 0 0112 22zm5-12.5l1.35-.45.4-1.35a8.572 8.572 0 00-1.925-2.063A7.978 7.978 0 0014.35 4.35L13 5.3v1.4l4 2.8zm-10 0l4-2.8V5.3l-1.35-.95c-.9.283-1.725.712-2.475 1.287A8.573 8.573 0 005.25 7.7l.4 1.35L7 9.5zm-1.05 7.7l1.15-.1.75-1.35L6.4 11.4 5 10.9l-1 .75c0 1.083.15 2.07.45 2.962.3.892.8 1.755 1.5 2.588zM12 20c.433 0 .858-.033 1.275-.1a7.735 7.735 0 001.225-.3l.7-1.5-.65-1.1h-5.1l-.65 1.1.7 1.5c.4.133.808.233 1.225.3.417.067.842.1 1.275.1zm-2.25-5h4.5l1.4-4L12 8.45 8.4 11l1.35 4zm8.3 2.2c.7-.833 1.2-1.696 1.5-2.588.3-.891.45-1.879.45-2.962l-1-.7-1.4.45-1.45 4.35.75 1.35 1.15.1z","fill":"#fff"}})])
          )
        }
      }
    